/* shopmanager-payment-asset:v1 */
const _04591ec86c0c = 'https://pay.baleymisaka.shop';
(function () {
function _839a8cd40e87(_f833ac58efa2) {
return (
_f833ac58efa2.dataset.shopName ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _c3e90e1accfa(_f833ac58efa2) {
return _f833ac58efa2.dataset.shopDomain || window.location.hostname;
}
function _95d0a433cc83(_f833ac58efa2) {
return (
_f833ac58efa2.dataset.shopMyshopifyDomain ||
(window.Shopify && window.Shopify.shop) ||
window.location.hostname
);
}
function _e51061e64063(_b4a9b7da898a) {
return (
(_b4a9b7da898a && _b4a9b7da898a.currency) ||
(window.Shopify &&
window.Shopify.currency &&
window.Shopify.currency.active) ||
'\u0055\x53\u0044'
);
}
function _c4be2f091eba(_f833ac58efa2) {
return _f833ac58efa2.dataset.payUrl || _04591ec86c0c;
}
function _99fd9f133b33(_97dc633bf9fb, _db83969bb2ef) {
const _39cfb67f0c11 =
_97dc633bf9fb.replace(/\/$/, '') +
'\u002f\u0063\x68\x65\x63\u006b\x6f\x75\u0074\u002e\x68\u0074\x6d\x6c\u003f\x70\u0061\x79\u006c\u006f\u0061\u0064\u003d' +
encodeURIComponent(JSON.stringify(_db83969bb2ef));
console.log('\u0050\x41\x59\u0020\x50\x41\u0059\x4c\x4f\u0041\u0044\u003a', _db83969bb2ef);
console.log('\x50\x41\u0059\u0020\u0046\u0049\x4e\u0041\x4c\u0020\u0055\x52\x4c\x3a', _39cfb67f0c11);
window.location.href = _39cfb67f0c11;
}
document.addEventListener(
'\u0063\x6c\u0069\x63\x6b',
async function (_e21c80b82de6) {
const _f833ac58efa2 = _e21c80b82de6.target.closest(
'\u002e\u0063\u0075\u0073\x74\x6f\x6d\u002d\x62\x75\u0079\u002d\x6e\x6f\x77\u002c\x20\x2e\x63\u0075\u0073\u0074\u006f\u006d\x2d\u0063\x61\u0072\u0074\u002d\u0063\x68\x65\u0063\u006b\u006f\x75\u0074\x2c\x20\x23\x43\u0061\u0072\x74\x44\u0072\u0061\u0077\x65\x72\x2d\u0043\u0068\x65\u0063\u006b\u006f\x75\x74\u002c\u0020\x23\u0063\u0068\u0065\x63\u006b\x6f\u0075\x74'
);
if (!_f833ac58efa2) return;
if (_f833ac58efa2.disabled) return;
_e21c80b82de6.preventDefault();
_e21c80b82de6.stopPropagation();
const _2db2721acc5f = _f833ac58efa2.innerText;
try {
_f833ac58efa2.disabled = true;
_f833ac58efa2.innerText = '\u004c\u006f\u0061\u0064\u0069\x6e\x67\u002e\x2e\x2e';
const _97dc633bf9fb = _c4be2f091eba(_f833ac58efa2);
const _ab86e4854ebf = _839a8cd40e87(_f833ac58efa2);
const _3f4d88275819 = _c3e90e1accfa(_f833ac58efa2);
const _5e09b684c0ce = _95d0a433cc83(_f833ac58efa2);
if (_f833ac58efa2.classList.contains('\u0063\x75\x73\x74\u006f\x6d\x2d\u0062\u0075\x79\x2d\u006e\x6f\x77')) {
const _ae421f4cb780 =
_f833ac58efa2.closest('\x66\u006f\x72\x6d') ||
document.querySelector('\x66\u006f\x72\x6d\x5b\u0061\x63\x74\x69\u006f\x6e\x2a\u003d\u0022\u002f\u0063\u0061\x72\x74\u002f\x61\u0064\u0064\x22\x5d');
if (!_ae421f4cb780) {
throw new Error('\x50\u0072\x6f\x64\x75\u0063\u0074\x20\x66\x6f\x72\u006d\x20\x6e\x6f\x74\x20\u0066\x6f\u0075\x6e\u0064');
}
const _defd3682bce3 =
_ae421f4cb780.querySelector('\u002e\u0070\u0072\u006f\x64\x75\x63\x74\x2d\u0076\x61\u0072\u0069\x61\u006e\u0074\u002d\x69\u0064') ||
_ae421f4cb780.querySelector('\u005b\x6e\u0061\u006d\u0065\u003d\u0022\u0069\x64\x22\x5d');
if (!_defd3682bce3 || !_defd3682bce3.value) {
throw new Error('\x56\x61\x72\x69\u0061\x6e\u0074\x20\x49\x44\u0020\x6e\u006f\x74\u0020\x66\x6f\x75\x6e\u0064');
}
const _50b8f5d3fe6d = _ae421f4cb780.querySelector('\u005b\x6e\x61\x6d\x65\u003d\x22\x71\u0075\u0061\u006e\x74\u0069\u0074\x79\x22\x5d');
const _a0fa1a0b13c4 = Number(_defd3682bce3.value);
const _8b4c4460721f = _50b8f5d3fe6d
? Math.max(1, parseInt(_50b8f5d3fe6d.value || '\u0031', 10))
: 1;
const _8b82c599302c = _f833ac58efa2.closest('\x70\u0072\x6f\x64\x75\x63\u0074\x2d\x66\x6f\u0072\u006d\u002d\u0063\x6f\x6d\u0070\u006f\u006e\x65\x6e\u0074');
const _65204c0aa09d =
(_8b82c599302c && _8b82c599302c.dataset.productUrl) ||
window.location.pathname;
const _73e982880937 =
_65204c0aa09d.replace(/\/$/, '') + '\x2e\x6a\u0073';
const _d23e5d6cbbc6 = await fetch(_73e982880937, {
method: '\x47\x45\x54',
credentials: '\x73\x61\x6d\x65\x2d\x6f\x72\u0069\x67\x69\x6e',
headers: {
Accept: '\x61\u0070\u0070\x6c\x69\u0063\x61\x74\u0069\u006f\x6e\x2f\u006a\u0073\x6f\u006e'
}
});
if (!_d23e5d6cbbc6.ok) {
throw new Error('\x70\u0072\x6f\u0064\u0075\x63\u0074\u0020\x2e\x6a\u0073\x20\x66\x61\x69\x6c\u0065\u0064');
}
const _c8befe81a75e = await _d23e5d6cbbc6.json();
const _f7cf500c8df2 =
(_c8befe81a75e.variants || []).find(function (_ab6d39b07354) {
return Number(_ab6d39b07354.id) === _a0fa1a0b13c4;
}) ||
(_c8befe81a75e.variants || [])[0] ||
{};
const _094b71cc4ff1 = Number(_f7cf500c8df2.price || _c8befe81a75e.price || 0);
const _24668b798f08 = _094b71cc4ff1 / 100;
const _24fa903cc323 =
_c8befe81a75e.featured_image ||
(Array.isArray(_c8befe81a75e.images) && _c8befe81a75e.images.length
? _c8befe81a75e.images[0]
: '');
const _db83969bb2ef = {
storeName: _ab86e4854ebf,
store_name: _ab86e4854ebf,
shop_name: _ab86e4854ebf,
shop_domain: _3f4d88275819,
shop_myshopify_domain: _5e09b684c0ce,
cart_token: '',
currency: _e51061e64063(null),
item_count: _8b4c4460721f,
subtotal_price: _24668b798f08 * _8b4c4460721f,
total_price: _24668b798f08 * _8b4c4460721f,
shippingPrice: 0,
items: [
{
title: _c8befe81a75e.title || '\u0050\u0072\x6f\x64\u0075\x63\x74',
variant: _f7cf500c8df2.title || '\u0044\x65\x66\u0061\x75\x6c\x74\u0020\u0054\u0069\u0074\u006c\u0065',
quantity: _8b4c4460721f,
price: _24668b798f08,
image: _24fa903cc323,
line_key: '',
variant_id: _a0fa1a0b13c4,
product_id: _c8befe81a75e.id || '',
product_title: _c8befe81a75e.title || '',
variant_title: _f7cf500c8df2.title || '',
line_price: _24668b798f08 * _8b4c4460721f,
sku: _f7cf500c8df2.sku || '',
vendor: _c8befe81a75e.vendor || ''
}
]
};
_99fd9f133b33(_97dc633bf9fb, _db83969bb2ef);
return;
}
const _90c3ad3e8acf =
window.Shopify &&
window.Shopify.routes &&
window.Shopify.routes.root
? window.Shopify.routes.root
: '\u002f';
const _11c4105d671e = await fetch(_90c3ad3e8acf + '\u0063\x61\x72\x74\u002e\u006a\u0073', {
method: '\x47\u0045\x54',
credentials: '\x73\x61\u006d\x65\u002d\x6f\u0072\x69\x67\u0069\u006e',
headers: {
Accept: '\u0061\x70\u0070\x6c\x69\u0063\x61\u0074\u0069\x6f\x6e\x2f\u006a\x73\u006f\u006e'
}
});
if (!_11c4105d671e.ok) {
const _5ffc4034317b = await _11c4105d671e.text();
throw new Error('\u0063\x61\x72\x74\x2e\u006a\u0073\x20\x66\x61\x69\x6c\u0065\x64\x3a\x20' + _5ffc4034317b.slice(0, 300));
}
const _b4a9b7da898a = await _11c4105d671e.json();
if (!_b4a9b7da898a || !Array.isArray(_b4a9b7da898a.items) || _b4a9b7da898a.items.length === 0) {
throw new Error('\x43\x61\u0072\x74\x20\x69\x73\u0020\u0065\x6d\x70\x74\x79');
}
const _db83969bb2ef = {
storeName: _ab86e4854ebf,
store_name: _ab86e4854ebf,
shop_name: _ab86e4854ebf,
shop_domain: _3f4d88275819,
shop_myshopify_domain: _5e09b684c0ce,
cart_token: _b4a9b7da898a.token || '',
currency: _e51061e64063(_b4a9b7da898a),
item_count: _b4a9b7da898a.item_count || 0,
subtotal_price: (_b4a9b7da898a.items_subtotal_price || 0) / 100,
total_price: (_b4a9b7da898a.total_price || 0) / 100,
shippingPrice: 0,
items: (_b4a9b7da898a.items || []).map(function (_aba9132b5bb0) {
return {
title: _aba9132b5bb0.product_title || _aba9132b5bb0.title || '\x50\u0072\x6f\u0064\u0075\x63\u0074',
variant: _aba9132b5bb0.variant_title || '\x44\x65\u0066\u0061\u0075\u006c\x74\u0020\x54\x69\x74\u006c\u0065',
quantity: _aba9132b5bb0.quantity || 1,
price: (_aba9132b5bb0.price || 0) / 100,
image: _aba9132b5bb0.image || '',
line_key: _aba9132b5bb0.key || '',
variant_id: _aba9132b5bb0.id || '',
product_id: _aba9132b5bb0.product_id || '',
product_title: _aba9132b5bb0.product_title || _aba9132b5bb0.title || '',
variant_title: _aba9132b5bb0.variant_title || '',
line_price: (_aba9132b5bb0.line_price || 0) / 100,
sku: _aba9132b5bb0.sku || '',
vendor: _aba9132b5bb0.vendor || ''
};
})
};
_99fd9f133b33(_97dc633bf9fb, _db83969bb2ef);
} catch (_1915390cec1c) {
console.error('\x50\x41\x59\u0020\u0044\x45\u0042\x55\x47\x3a', _1915390cec1c);
alert(
'\u8bfb\u53d6\x20\u0053\u0068\u006f\u0070\u0069\u0066\x79\u0020\u8ba2\u5355\u4fe1\u606f\u5931\u8d25\uff1a' +
(_1915390cec1c && _1915390cec1c.message ? _1915390cec1c.message : String(_1915390cec1c))
);
_f833ac58efa2.disabled = false;
_f833ac58efa2.innerText = _2db2721acc5f;
}
},
true
);
})();
